import React from 'react';
import { editForm } from '../utils/list_data';
import notice from 'src/common/components/Notice';
import BaseModal from 'src/common/components/Modal';
import UtilInputs from 'src/common/components/UtilInputs';
import { parameterAPI } from 'src/api/modules/parameters';

const EditParam = ({ open, onClose, onSuccess, parameter, onChangeData }) => {
	const onSave = () => {
		parameterAPI
			.putParameter(parameter)
			.then(() => {
				onSuccess('Parámetro actualizado', 'success', 2);
			})
			.catch(() => {
				notice('Ocurrió un error al actualizar la información');
			});
	};

	return (
		<BaseModal
			open={open}
			mainText="Editar Parámetro"
			onConfirm={onSave}
			confirmLabel="Guardar"
			onClose={onClose}
			onCancel={onClose}
		>
			<UtilInputs
				formValues={parameter}
				inputValues={editForm}
				onValuesChange={onChangeData}
			/>
		</BaseModal>
	);
};

export default EditParam;
